<template>
  <div class="suosittele">
    <h4>Kaverille kans!</h4>
    <p v-if="error" class="air">
      Vinkkaa kaverille ilmaisesta kokeilusta! Lähetä passin lataus -linkki
      helposti painamalla haluamaasi kuvaketta alapuollella. Voit lähettää
      linkin Facebookissa,
      <span class="hide-dt">Messengerissä,</span> Whatsappilla tai
      sähköpostilla!
    </p>
    <p v-else class="air">
      Ota kaveri mukaan treenaamaan! Lähetä passin lataus -linkki helposti
      painamalla haluamaasi kuvaketta alapuollella. Voit lähettää linkin
      Facebookissa, <span class="hide-dt">Messengerissä,</span> Whatsappilla tai
      sähköpostilla!
    </p>
    <div class="icons">
      <vs-button
        class="float"
        color="facebook"
        :href="getSelectedClub.shares.facebook"
        circle
        icon
        floating
        blank
      >
        <i class="bx bxl-facebook"></i>
      </vs-button>

      <vs-button
        class="float hide-dt"
        color="messenger"
        :href="getSelectedClub.shares.messenger"
        circle
        icon
        floating
        blank
      >
        <i class="bx bxl-messenger"></i>
      </vs-button>

      <vs-button
        class="float"
        color="whatsapp"
        :href="getSelectedClub.shares.whatsapp"
        data-action="share/whatsapp/share"
        circle
        icon
        floating
      >
        <i class="bx bxl-whatsapp"></i>
      </vs-button>

      <vs-button
        class="float"
        color="primary"
        :href="getSelectedClub.shares.email"
        circle
        icon
        floating
      >
        <i class="bx bx-envelope"></i>
      </vs-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Suosittele",
  computed: mapGetters(["getSelectedClub"]),
  props: ["error"]
};
</script>

<style scoped>
h4 {
  margin-bottom: 1em;
}
.icons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 2em 0;
}
.float {
  opacity: 0;
  animation: fade 2s forwards, float 4s infinite ease-in-out;
}
.float:not(:last-child) {
  margin-right: 1em;
}
.float:nth-child(1) {
  animation-delay: 1s;
}
.float:nth-child(2) {
  animation-delay: 1.5s;
}
.float:nth-child(3) {
  animation-delay: 2s;
}
.float:nth-child(4) {
  animation-delay: 2.5s;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes float {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(0px, 16px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@media (min-width: 1025px) {
  .hide-dt {
    display: none;
  }
}
</style>
